import { render, staticRenderFns } from "./InspectionInfoUDI.vue?vue&type=template&id=40c7e0f2&scoped=true&"
import script from "./InspectionInfoUDI.vue?vue&type=script&lang=js&"
export * from "./InspectionInfoUDI.vue?vue&type=script&lang=js&"
import style0 from "./InspectionInfoUDI.vue?vue&type=style&index=0&id=40c7e0f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7e0f2",
  null
  
)

export default component.exports